@if (!isLoading()) {
  <div
    [class]="
      'chip d-flex flex-row radius-giant align-items-center border-color-light surface-elevated  ' +
      generatedWrapperClasses() +
      ' ' +
      classes()
    "
    (mouseenter)="handleWrapperHover(true)"
    (mouseleave)="handleWrapperHover(false)"
    (click)="handlePress()"
  >
    <!-- Leading Component -->
    <ng-content select="[leadingComponent]"></ng-content>
    <!-- End Leading Component -->

    <!-- Leading Icon -->
    @if (leadingIcon() && leadingIcon() !== '') {
      <common-icon-dp-icon
        [icon]="leadingIcon()"
        [iconType]="leadingIconType()"
        [secondaryColor]="leadingIconColor()"
        [styles]="leadingIconStyle()"
        [iconSize]="'16'"
        [gradientMode]="isLeadingIconTinted() ? 'tint' : 'none'"
        [classes]="generatedTextClasses()"
      ></common-icon-dp-icon>
    }
    <!-- End Leading Icon -->

    <!-- Label -->
    @if (!hideLabel()) {
      <div [class]="'chip-label px-tiny ' + sizeToTextTypographyMap[size()] + ' ' + generatedTextClasses()">
        {{ label() }}
      </div>
    }
    <!-- End Label -->

    <!-- Trailing Component -->
    <ng-content select="[trailingComponent]"></ng-content>
    <!-- End Trailing Component -->

    <!-- Trailing Icon -->
    @if (trailingIcon() && trailingIcon() !== '' && pressed()) {
      <div
        [@.disabled]="disableAnimations()"
        [@appear]
        class="trailing-icon"
        (click)="handleTrailingChipClick($event)"
      >
        <common-icon-dp-icon
          [icon]="trailingIcon()"
          [iconType]="trailingIconType()"
          [secondaryColor]="trailingIconColor()"
          [iconSize]="'16'"
          [style]="trailingIconStyle()"
          [gradientMode]="isTrailingIconTinted() ? 'tint' : 'none'"
          [classes]="generatedTextClasses()"
        ></common-icon-dp-icon>
      </div>
    }
    <!-- End Trailing Icon -->
  </div>
} @else {
  <lib-ngx-skeleton-loading
    [classes]="'radius-giant'"
    [height]="size() === 'MEDIUM' ? '28px' : size() === 'SMALL' ? '24px' : '40px'"
    [width]="size() === 'MEDIUM' ? '111px' : size() === 'SMALL' ? '98px' : '125px'"
  >
  </lib-ngx-skeleton-loading>
}
